// extracted by mini-css-extract-plugin
module.exports = {"back":"-vNJrd3dl47Hh9HgABXSy"};